import { render, staticRenderFns } from "./ProtocolSettings.vue?vue&type=template&id=46150594"
import script from "./ProtocolSettings.vue?vue&type=script&lang=js"
export * from "./ProtocolSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports